<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <el-row type="flex" style="margin-bottom:10px">
      <el-input v-model="identifier" placeholder="请输入服务标识符"  style="width:20%;margin-right:10px"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="search"></el-button>
        <el-select v-model="timeValue" @change="selChange" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        <el-date-picker
            :clearable="false"
            v-show="showDate"
            v-model="dateTime"
            @change="dateChage"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="createTime"
          label="时间">
          <template slot-scope="scope">
            <div>
              {{dateFormat(scope.row.createTime)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
         prop="identifier"
          label="标识符">
        </el-table-column>
        <el-table-column
          label="服务名称">
          <template slot-scope="scope">
            <div>
              {{key2chinese[scope.row.identifier]?key2chinese[scope.row.identifier]:''}}
            </div>
          </template>
        </el-table-column>
         <el-table-column
          label="输入参数">
          <template slot-scope="scope">
            <div>
              {{scope.row.inputData}}
            </div>
          </template>
        </el-table-column>
         <el-table-column
          label="输出参数">
          <template slot-scope="scope">
            <div>
              {{scope.row.outputData}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
      <el-row
        class="pagination-container"
        type="flex" justify="end"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
        <el-pagination
          :current-page.sync="listQuery.page"
          :page-sizes="[5,15,20,30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
      </el-row>
  </div>
</template>

<script>
import { deviceServiceLog } from '@/api/deviceManagement'
import { dateFormat } from '@/assets/js/tools.js'
export default {
  props: ['deviceDetail', 'services'],
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      btnsName: '',
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      dateParams: {
        startTime: '',
        endTime: ''
      },
      options: [{
        value: '1',
        label: '1小时'
      }, {
        value: '2',
        label: '24小时'
      }, {
        value: '3',
        label: '7天'
      }, {
        value: '4',
        label: '自定义'
      }],
      timeValue: '3',
      dateTime: '',
      showDate: false,
      identifier: '',
      searchIdentifier: '', // 用于点击搜索按钮赋值
      key2chinese: {},
      dateFormat: dateFormat
    }
  },
  created () {
    console.log('this.deviceDetail:', this.deviceDetail)
    // 初始化中英文对照对象
    this.initKey2Chinese(this.services)
    console.log('this.key2chinese:', this.key2chinese)
    // 初始化时间
    this.getDate(this.timeValue)
    this.getDeviceServiceLog()
  },
  methods: {
    initKey2Chinese (list) {
      list.map(item => {
        this.key2chinese[item.identifier] = item.name
      })
    },
    search () {
      this.searchIdentifier = this.identifier
      this.getDeviceServiceLog()
    },
    dateChage () {
      this.listQuery.page = 1
      // console.log('日期变更：', this.dateTime)
      this.dateParams.startTime = Date.parse(this.dateTime[0])
      this.dateParams.endTime = Date.parse(this.dateTime[1])
      // 切换选项相当于搜索，要把input框的输入值给搜索的参数
      this.searchIdentifier = this.identifier
      // 获取数据
      this.getDeviceServiceLog()
    },
    selChange (value) {
      value === '4'
        ? this.showDate = true
        : (
          this.showDate = false,
          // 初始起始时间
          this.getDate(value),
          // 切换选项相当于搜索，要把input框的输入值给搜索的参数
          this.searchIdentifier = this.identifier,
          this.getDeviceServiceLog()
        )
    },
    getDate (type) {
      // 用于获起始时间的时间戳,毫秒
      const dateParams = {
        beginTime: Date.parse(new Date()),
        endTime: Date.parse(new Date()),
        oneHourTiem: 60 * 60 * 1000,
        oneDayTime: 24 * 60 * 60 * 1000
      }
      this.dateParams.endTime = dateParams.endTime
      type === '1'// 小时
        ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneHourTiem
        : type === '2'// 24小时
          ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneDayTime
          : type === '3'// 7天
            ? this.dateParams.startTime = dateParams.beginTime - (dateParams.oneDayTime * 7)
            : ''
    },
    getDeviceServiceLog () {
      console.log(8888888888)
      const params = {
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        deviceName: this.deviceDetail.deviceName,
        productKey: this.deviceDetail.productKey,
        identifier: this.searchIdentifier,
        startTime: this.dateParams.startTime,
        endTime: this.dateParams.endTime
      }
      console.log('请求的参数：', params)
      deviceServiceLog(params).then(res => {
        res = res.data
        console.log('====================================')
        console.log('返回的数据：', res)
        console.log('====================================')
        this.tableData = res.data.list
        this.total = res.data.recordCount
      })
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getBtnsList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getBtnsList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .el-select{
      margin-right: 10px;
      margin-left: 10px;
    }
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
